import { isHexColor as t } from "./watson.es43.js";
import { SIZE_MEDIUM as a } from "./watson.es38.js";
import { ICON_NAMES as n, ICON_BASE_COLORS as l, ICON_SIZES as c } from "./watson.es45.js";
import d from "./watson.es65.js";
import { openBlock as m, createBlock as s, resolveDynamicComponent as u } from "vue";
import "./watson.WIcon.es2.js";
import f from "./watson.es37.js";
import o from "./watson.es66.js";
const p = {
  name: "WIcon",
  mixins: [d],
  props: {
    /**
     * Icon name in the kebab-case format
     * */
    name: {
      type: String,
      required: !0,
      validator: (e) => n.includes(e)
    },
    /**
     * Sets the icon color
     * @values primary , secondary , muted , inverted , accent , success , warning , danger , accent-inverted , success-inverted , info, info-inverted, danger-inverted , any hexadecimal color (#176d00)
     * @default muted
     * */
    color: {
      required: !1,
      type: String,
      default: "muted",
      validator: (e) => !e || l.includes(e) || t(e)
    },
    /**
     * Defines the size of the icon
     * @values small, medium, large
     * @default medium
     * */
    size: {
      required: !1,
      type: String,
      default: a,
      validator: (e) => !e || c.includes(e)
    },
    /**
     * Indicates whether the element is exposed to an accessibility API. This can be used for hiding decorative icons that already display a visible and accessible label.
     * @values true, false
     * */
    ariaHidden: {
      required: !1,
      type: Boolean,
      default: !1
    },
    /**
     * Defines a string value that labels an element.
     * */
    ariaLabel: {
      required: !1,
      type: String,
      default: null
    }
  },
  data() {
    return {
      iconCategory: null
    };
  },
  computed: {
    category() {
      return o[this.name].iconCategory;
    },
    component() {
      const { componentName: e } = o[this.name];
      return e;
    }
  }
};
function _(e, S, r, y, C, i) {
  return m(), s(u(i.component), {
    "aria-hidden": r.ariaHidden,
    "aria-label": r.ariaLabel,
    color: r.color,
    size: r.size
  }, null, 8, ["aria-hidden", "aria-label", "color", "size"]);
}
const M = /* @__PURE__ */ f(p, [["render", _]]);
export {
  M as default
};
